// extracted by mini-css-extract-plugin
export default {"destroy_root":"TrashedActions_destroy_root__xDz2m"};